import { render, staticRenderFns } from "./OrderFee.vue?vue&type=template&id=1a15d32c&scoped=true"
import script from "@/views/OrderFee/OrderFee.ts?vue&type=script&lang=ts&external"
export * from "@/views/OrderFee/OrderFee.ts?vue&type=script&lang=ts&external"
import style0 from "./order_fee.scss?vue&type=style&index=0&id=1a15d32c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15d32c",
  null
  
)

export default component.exports